export {default as formatDefaultLocale, format, formatPrefix} from "./src/defaultLocale";
export {default as formatLocale} from "./src/locale";
export {default as formatSpecifier} from "./src/formatSpecifier";
export {default as precisionFixed} from "./src/precisionFixed";
export {default as precisionPrefix} from "./src/precisionPrefix";
export {default as precisionRound} from "./src/precisionRound";



//////////////////
// WEBPACK FOOTER
// ./~/d3-format/index.js
// module id = 335
// module chunks = 1